import { Hero } from "@/components/sections/Hero";
import { KeyFigures } from "@/components/sections/KeyFigures";
import { CapabilitiesGrid } from "@/components/sections/CapabilitiesGrid";
import { ProjectsStrip } from "@/components/sections/ProjectsStrip";
import { PartnerMarquee } from "@/components/sections/PartnerMarquee";
import { CtaBand } from "@/components/sections/CtaBand";

export default function Home() {
  return (
    <main data-testid="home-page">
      <Hero />
      <KeyFigures />
      <CapabilitiesGrid />
      <ProjectsStrip />
      <PartnerMarquee />
      <CtaBand />
    </main>
  );
}
